export default __webpack_public_path__ + "static/media/404.913973d7.png";